// extracted by mini-css-extract-plugin
export default {"groupsEmpty":"styles_groupsEmpty__5lXJn","txt":"styles_txt__-77cr"};